// extracted by mini-css-extract-plugin
module.exports = {"studentWarrper":"StudentScore_studentWarrper__Xjx4B","HoverClass":"StudentScore_HoverClass__dgiE2"};